module.exports = __webpack_public_path__ + "img/icon_jpy.013b4a0d.svg";